import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { CATEGORY_COLORS, CATEGORY_LABELS } from './template-category.constants';

/**
 * Shared email-template badges, extracted from CommunicationTemplatesPage so the
 * tenant Settings page and the Platform Console library stay visually identical
 * (COMMUNICATION_DESIGN.md §5.7 — D3). Behaviour is unchanged from the originals.
 */

const BADGE_BASE = 'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium';

export function StatusBadge({ status, isArchived }: { status: string; isArchived: boolean }) {
  if (isArchived) {
    return <span className={`${BADGE_BASE} bg-muted text-muted-foreground`}>Archived</span>;
  }
  const cfg: Record<string, string> = {
    DRAFT: 'bg-muted text-muted-foreground',
    ACTIVE: 'bg-green-500/10 text-green-700 dark:text-green-400',
    DISABLED: 'bg-amber-500/10 text-amber-700 dark:text-amber-400',
  };
  const label: Record<string, string> = { DRAFT: 'Draft', ACTIVE: 'Active', DISABLED: 'Disabled' };
  return (
    <span className={`${BADGE_BASE} ${cfg[status] ?? cfg.DRAFT}`}>{label[status] ?? status}</span>
  );
}

export function ChannelBadge({ channel }: { channel: string }) {
  if (channel === 'EMAIL') {
    return (
      <span className={`${BADGE_BASE} gap-1 bg-primary/10 text-primary`}>
        <FontAwesomeIcon icon={faEnvelope} className="h-2.5 w-2.5" />
        Email
      </span>
    );
  }
  return <span className={`${BADGE_BASE} bg-muted text-muted-foreground`}>Coming Soon</span>;
}

export function CategoryBadge({ category }: { category: string }) {
  return (
    <span className={`${BADGE_BASE} ${CATEGORY_COLORS[category] ?? CATEGORY_COLORS.SYSTEM}`}>
      {CATEGORY_LABELS[category] ?? category}
    </span>
  );
}
